
import qrCode from "../common/qr-code.vue";
import OrderBarcode from "../reciever/order-barcode.vue";
import cancelledImg from "~/assets/images/cancelledImage.svg";

export default {
  components: { qrCode, OrderBarcode },
  data() {
    return {
      cancelledImg
    };
  },
  methods: {
    getPrintWidth() {
      const pixelsPerInch = 86;
      let isSmallPrinter = false;
      const printScale = isSmallPrinter ? 2 : 3;
      return pixelsPerInch * printScale;
    }
  }
};
